import "./App.css";
import Nav from "./components/Nav/Nav";
import FirstSection from "./components/FirstSection/FirstSection";
import SecondSection from "./components/SecondSection/SecondSection";
import ThirdSection from "./components/ThirdSection/ThirdSection";
import FourthSection from "./components/FourthSection/FourthSection";
import Footer from "./components/footer/Footer";
import { useEffect, useRef } from "react";
function App() {
  const sections = useRef([]);
  const dummy = useRef(null);
  const nav = useRef(null);
  const ab = useRef(null);
  const pr = useRef(null);
  const sk = useRef(null);
  const hr = useRef(null);
  useEffect(() => {
    let topPage = (entries, observer) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          nav.current.classList.remove("dark");
        } else {
          nav.current.classList.add("dark");
        }
      });
    };

    let observer = new IntersectionObserver(topPage, { threshold: 1 });
    if (dummy.current) observer.observe(dummy.current);
  }, []);
  return (
    <div className="App">
      <Nav
        sections={sections}
        dummy={dummy}
        ab={ab}
        sk={sk}
        pr={pr}
        hr={hr}
        nav={nav}
      />
      <FirstSection sections={sections} />
      <SecondSection sections={sections} />
      <ThirdSection sections={sections} />
      <FourthSection sections={sections} />
      <Footer />
    </div>
  );
}

export default App;
